<template>
  <!-- Current Claaims in Homepage -->
  <div class="flex flex-col">
    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-2">
      <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-2">
        <div
          class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
        >
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Case#/Type
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Member
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Legal Matter
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Submitted
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Status
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="(item, i) in data" :key="i">
                <template v-if="i < 10">
                  <td class="px-6 py-4 whitespace-nowrap text-left">
                    <div class="flex items-center">
                      <div class="ml-4">
                        <div
                          v-if="item?.case_number"
                          class="text-sm font-medium text-gray-900"
                        >
                          {{ item?.case_number }}
                        </div>
                        <div
                          v-if="item?.number"
                          class="text-sm font-medium text-gray-900"
                        >
                          {{ item?.number }}
                        </div>
                        <div class="text-sm text-gray-500">
                          {{ item?.type }}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-left">
                    <div class="text-sm text-gray-900">
                      {{ item?.member_name }}
                    </div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-left">
                    <span
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                    >
                      {{ item?.desc }}
                    </span>
                  </td>
                  <td
                    v-if="item.type == 'Matter'"
                    class="text-left px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                  >
                    {{ setDateFormat(item?.submitted_date) }}
                  </td>
                  <td
                    v-if="item.type == 'CDL'"
                    class="text-left px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                  >
                    {{ setDateFormat(item?.date_created) }}
                  </td>
                  <td
                    class="px-6 py-4 whitespace-nowrap text-left"
                    v-if="item.type == 'CDL'"
                  >
                    <span
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                    >
                      {{ item?.status }}
                    </span>
                  </td>
                  <td
                    class="px-6 py-4 whitespace-nowrap text-left"
                    v-if="item.type == 'Matter'"
                  >
                    <span
                      v-if="item?.claim_status == 'Intake'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                    >
                      {{ item?.claim_status }}
                    </span>
                    <span
                      v-if="item?.claim_status == 'In Process'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800"
                    >
                      {{ item?.claim_status }}
                    </span>
                    <span
                      v-if="item?.claim_status == 'Open Authorization Issue'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800"
                    >
                      {{ item?.claim_status }}
                    </span>
                    <span
                      v-if="item?.claim_status == 'Requested More Info'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-purple-100 text-purple-800"
                    >
                      {{ item?.claim_status }}
                    </span>
                    <span
                      v-if="item?.claim_status == 'New Info Received'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800"
                    >
                      {{ item?.claim_status }}
                    </span>
                    <span
                      v-if="
                        item?.claim_status == 'Pending Approval for Payment'
                      "
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800"
                    >
                      {{ item?.claim_status }}
                    </span>
                    <span
                      v-if="item?.claim_status == 'Approved & Paid'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                    >
                      {{ item?.claim_status }}
                    </span>
                    <span
                      v-if="item?.claim_status == 'Denied'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
                    >
                      {{ item?.claim_status }}
                    </span>
                    <!--<span
                  v-if="item?.status == 'Intake'"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                >
                  {{ item?.status }}
                </span>
                <span
                  v-if="item?.status == 'In Process'"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800"
                >
                  {{ item?.status }}
                </span>
                <span
                  v-if="item?.status == 'Requested More Info'"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800"
                >
                  {{ item?.status }}
                </span>
                <span
                  v-if="item?.status == 'Pending Approval for Payment'"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800"
                >
                  {{ item?.status }}
                </span>
                <span
                  v-if="item?.status == 'Approved & Paid'"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                >
                  {{ item?.status }}
                </span>
                <span
                  v-if="item?.status == 'Denied	'"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
                >
                  {{ item?.status }}
                </span>
                <span
                  v-if="item?.status == 'Referral'"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800"
                >
                  {{ item?.status }}
                </span>
                <span
                  v-if="item?.status == 'New Info Received'"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800"
                >
                  {{ item?.status }}
                </span>-->
                  </td>
                </template>
              </tr>

              <tr v-if="data?.length <= 0">
                <td class="text-center p-3" colspan="6">
                  No Records Found
                </td>
              </tr>

              <!-- More people... -->
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Constants from "../../constants.ts"; // importing constant resubale variables.

export default {
  name: "List",
  data() {
    return {
      setDateFormat: Constants.setDateFormat,
    };
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {},
};
</script>
